import { Button, Flex, rem } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import { DEFAULT_DURATION, Duration, DurationSelection } from '@ospace/common'
import dayjs from 'dayjs'

interface Props {
  duration: Duration
  setDuration: (selection: DurationSelection) => void
}

export const DurationPicker = ({ duration, setDuration }: Props) => {
  const durationSelection = ['Month', 'Quarter', 'FY'] as const

  return (
    <Flex mih={50} bg='white' gap='md' justify='flex-start' align='center' direction='row'>
      {durationSelection.map((item) => (
        <Button
          key={item}
          variant={item === duration?.selection ? 'light' : 'subtle'}
          styles={(theme) => ({
            root: {
              color: theme.colors.gray[7],
              lineHeight: 1,
              padding: `${rem(8)} ${rem(12)}`,
              borderRadius: theme.radius.sm,
              textDecoration: 'none',
              fontSize: theme.fontSizes.sm,
              fontWeight: item === duration?.selection ? 700 : 500,
              backgroundColor: item === duration?.selection ? theme.colors.gray[0] : 'white',
              '&:hover': {
                backgroundColor: theme.colors.gray[1],
              },
            },

            leftIcon: {
              marginRight: theme.spacing.md,
            },
          })}
          onClick={() => {
            setDuration(item)
          }}
        >
          {item}
        </Button>
      ))}
      <DatePickerInput
        type='range'
        placeholder='Select date range'
        value={Array.isArray(duration?.selection) ? duration?.selection : [null, null]}
        onChange={(value) => {
          value.forEach((date) => {
            if (date && dayjs(date).isValid()) {
              setDuration(value)
            }
          })

          if (!value[0] && !value[1]) {
            //clear date range
            setDuration(DEFAULT_DURATION)
          }
        }}
        miw={200}
        numberOfColumns={2}
        clearable
        styles={(theme) => ({
          input: {
            '&:hover': {
              backgroundColor: theme.colors.gray[1],
            },
            ...(Array.isArray(duration?.selection) && {
              color: theme.colors.gray[7],
              fontWeight: 600,
              border: 0,
              backgroundColor: theme.colors.gray[0],
            }),
          },
        })}
      />
    </Flex>
  )
}
